export const RESET = 'BACKUP_TYPE_UPDATE_RESET'
export const SET_ERROR = 'BACKUP_TYPE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'BACKUP_TYPE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'BACKUP_TYPE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'BACKUP_TYPE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'BACKUP_TYPE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'BACKUP_TYPE_UPDATE_UPDATE_RETRIEVED'
export const SET_FILES = 'BACKUP_TYPE_UPDATE_FILES'
